module.exports = __webpack_public_path__ + "assets/9c7ce571c988eaec05dc05c0116addb0.mp3";